var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","small":"","color":_vm.getColorEstado(_vm.state)}},[_vm._v("\n    "+_vm._s(_vm.state)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }